import * as React from 'react';
import { cn } from '../../lib/utils';

const VARIANTS = {
  // Основное действие — accent по MASTER.md
  primary:
    'bg-accent text-white border border-accent hover:bg-accent-hover hover:border-accent-hover shadow-sm',
  // Второстепенное — контурная кнопка primary-цвета
  secondary:
    'bg-transparent text-primary border border-primary hover:bg-primary-soft',
  // Нейтральная кнопка панели инструментов
  ghost:
    'bg-surface-raised text-text-muted border border-border hover:text-text hover:bg-muted hover:border-border-strong',
  danger:
    'bg-transparent text-destructive border border-destructive/40 hover:bg-destructive-soft hover:border-destructive',
  // Кнопка-иконка без рамки (например, закрыть модалку)
  plain:
    'bg-transparent text-text-muted border border-transparent hover:text-text hover:bg-muted',
};

const SIZES = {
  sm: 'h-7 px-md gap-sm text-body-xs rounded-md',
  md: 'h-9 px-lg gap-md text-body-sm rounded-md',
  lg: 'h-11 px-xl gap-md text-body-md rounded-lg',
  icon: 'h-7 w-7 justify-center rounded-md',
  'icon-md': 'h-9 w-9 justify-center rounded-md',
};

/**
 * Единая кнопка приложения.
 * icon — класс bootstrap-icons (например "bi-trash"); при size="icon"
 * обязателен title/aria-label, иначе кнопка недоступна скринридеру.
 */
const Button = React.forwardRef(
  (
    { className, variant = 'ghost', size = 'md', icon, loading = false, disabled, children, ...props },
    ref
  ) => (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={cn(
        'inline-flex items-center font-medium whitespace-nowrap cursor-pointer',
        'transition-colors duration-200',
        'disabled:opacity-45 disabled:cursor-not-allowed disabled:pointer-events-none',
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...props}
    >
      {loading ? (
        <i className="bi bi-arrow-repeat animate-spin" aria-hidden="true" />
      ) : (
        icon && <i className={cn('bi', icon)} aria-hidden="true" />
      )}
      {children}
    </button>
  )
);
Button.displayName = 'Button';

export { Button };
